import { Link } from "react-router-dom";
import { ArrowRight, Hammer, Drum, Home, HeartHandshake, BookOpen, Users } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { useLocale } from "@/context/LocaleContext";

const ACCES = [
  { icon: Hammer, titre: "Créer un tambour", texte: "Stages de création en groupe, individuels ou privatisés", to: "/offres/stage-fabrication-tambour", id: "creer" },
  { icon: Drum, titre: "Choisir un tambour", texte: "Pièces uniques en boutique et tambours réalisés", to: "/boutique", id: "choisir" },
  { icon: HeartHandshake, titre: "Être accompagné·e", texte: "Consultation holistique, soins énergétiques à distance", to: "/offres/consultations-holistiques", id: "accompagne" },
  { icon: Home, titre: "Harmoniser un lieu", texte: "Géobiologie, nettoyage et harmonisation — maison ou bureau", to: "/offres/lieux-habitats", id: "lieu" },
  { icon: BookOpen, titre: "Apprendre & pratiquer", texte: "Le Wyrd — parcours de 6 mois pour développer sa pratique du tambour", to: "/le-wyrd", id: "apprendre" },
  { icon: Users, titre: "Participer", texte: "Cercles, randonnées, soirées découverte et voyages — toutes les dates", to: "/agenda", id: "participer" },
];

export const HomeQuickAccess = () => {
  const { t } = useLocale();
  return (
  <section className="max-w-7xl mx-auto px-6 lg:px-10 py-20 lg:py-24" data-testid="home-quick-access">
    <Reveal className="flex flex-wrap items-end justify-between gap-6 mb-10">
      <h2 className="font-serif text-3xl sm:text-4xl text-bark leading-tight">{t("Que souhaitez-vous faire ?")}</h2>
      <p className="text-sm text-fumee max-w-sm">{t("Six portes d'entrée — choisissez la vôtre.")}</p>
    </Reveal>
    <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3 lg:gap-4">
      {ACCES.map(({ icon: Icon, titre, texte, to, id }, i) => (
        <Reveal key={id} delay={i * 0.06} className={i > 3 ? "hidden sm:block" : ""}>
          <Link to={to} data-testid={`quick-access-${id}`} className="group flex items-start gap-4 rounded-2xl border border-sand-dark bg-card p-5 lg:p-6 h-full hover:border-terra/60 hover:-translate-y-0.5 transition-[border-color,transform] duration-300">
            <span className="w-11 h-11 rounded-full bg-sand-dark/70 text-terra flex items-center justify-center shrink-0 group-hover:bg-terra group-hover:text-earth transition-colors duration-300"><Icon className="w-5 h-5" /></span>
            <span className="min-w-0 flex-1">
              <span className="block font-serif text-xl text-bark leading-tight">{t(titre)}</span>
              <span className="block text-sm text-fumee mt-1.5 leading-snug">{t(texte)}</span>
            </span>
            <ArrowRight className="w-4 h-4 text-terra/70 mt-1 shrink-0 transition-transform duration-300 group-hover:translate-x-1" />
          </Link>
        </Reveal>
      ))}
    </div>
  </section>
  );
};
